/**
 * Styling for password input fields with visibility toggle icon.
 * Handles Material-UI overrides and browser autofill styling.
 * @type {Object}
 */
export const passwordFieldSx = {
    "& .MuiOutlinedInput-root": {
        "&:has(input:-webkit-autofill)": {
            backgroundColor: "#e8f0fe",
            borderRadius: 1,
        },
        "&:has(input:-webkit-autofill) .MuiInputAdornment-root": {
            backgroundColor: "#e8f0fe",
        },
        // !important is required to override MUI's default hover/focus background styles.
        "& .MuiIconButton-root": {
            backgroundColor: "transparent !important",
        },
        "& .MuiIconButton-root:hover": {
            backgroundColor: "transparent !important",
        },
    },
};
